import { useEffect, useRef, useState } from "react"
import { _AdquisitionItem, _HelpDesk, _RequestAdquisitionItem, _single, _Test } from "../../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { MisPlanesPreparadorComponentEditor } from "./Componentes/MisPlanesPreparadorComponentEditor";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const SPAA002 = ({ configProcedure }: Props) => {

    const { _procedure, _pocessData, _exportMap, _pushInfo, _pushProps } = configProcedure;
    const item = useDataBean(_AdquisitionItem);
    const { instance, spin, bean, setBean } = useDataBean(_RequestAdquisitionItem);

    const [view, setView] = useState<number>(1);

    const [props, setProps] = useState<any>({});
    const [paa, setPaa] = useState<any>({});

    useEffect(() => {
        if (_pocessData?.Props) {
            setProps(_pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    useEffect(() => {
        if (props?.IDRequestAdquisitionItem) {
            instance.getRequestAdquisitionItem(props?.IDRequestAdquisitionItem).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo obtener la información") })
        }
    }, [props?.IDRequestAdquisitionItem])


    const handleButtonClick = (approveValue: "true" | "false") => {
        const newResponse = { ...bean, Approve: approveValue };
        setBean(newResponse);
        if (approveValue === "true") {
            handleApprove(newResponse);
        } else {
            handleDecline(newResponse);
        }
    };

    const handleApprove = (currentResponse) => {
        if (currentResponse?.Obs?.length > 15) {
            setView(2)
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };

    const handleDecline = (currentResponse) => {
        if (currentResponse.Obs.length > 15) {
            enviardata({ ...currentResponse, Approve: "false" });
        } else {
            toast.error("La justificación debe tener mínimo 15 caracteres");
        }
    };


    const updateEvent = (newData: any) => {
        if (_pushInfo && bean.Approve == "true") {
            configProcedure?._pushInfo(_single.jsonToBootstrapTable({
                "Estado de Gestion": "Aprobada",
                "Observaciones": newData.Obs,
                "ID de Necesidad": paa?.IDAdquisitionItem,
                "Descripción Necesidad": paa?.Description
            }));
        } else if (_pushInfo && bean.Approve == "false") {
            configProcedure?._pushInfo(_single.jsonToBootstrapTable({
                "Estado de Gestion": "Rechazada",
                "Observaciones": newData.Obs,
            }));
        }
        if (_exportMap) {
            configProcedure?._exportMap({
                Approve: newData.Approve,
                Obs: newData.Obs
            });
        }
        if (_pushProps) {
            configProcedure?._pushProps(newData);
        }
    }

    const enviardata = (newData?: any) => {
        instance.updateRequestAdquisitionItem({ ...newData }).then(
            (resp) => {

                if (paa.IDAdquisitionItem) {

                    item.instance.changeAdquisitionItemApprovalNote(paa.IDAdquisitionItem, _single.getAccountID(), newData.Obs, 4)
                        .then((resp) => {
                            updateEvent(newData);
                        })
                        .catch(err => console.log(err));
                } else {
                    updateEvent(newData);
                }
            }
        ).catch(err => { toast.error("No se pudo realizar la accion"); console.log(err) })

    }

    useEffect(() => { setPaa({}) }, [view])

    return (
        <div className="row">
            {view == 1 &&
                <div className="row d-flex justify-content-between">

                    <div className="rowCredits">
                        <span className="label">Justificación:</span>
                        <span className="value" dangerouslySetInnerHTML={{ __html: bean.JustifyItem }} />
                    </div>

                    <div className="rowCredits">
                        <span className="label">Área Solicitante:</span>
                        <span className="value" dangerouslySetInnerHTML={{ __html: bean.FunctionalIDLnRequest }} />
                    </div>
                    <div className="rowCredits">
                        <span className="label">Área Solicitada:</span>
                        <span className="value" dangerouslySetInnerHTML={{ __html: props.AreaRequestedName }} />
                    </div>
                    <div className="rowCredits">
                        <span className="label">Valor: </span>
                        <span className="value" dangerouslySetInnerHTML={{ __html: bean.Amount }} />
                    </div>

                    <div className="col-md-12 mb-2">
                        <label>Observaciones</label>
                        <textarea className="form-control" value={bean.Obs} onChange={(e) => { setBean({ ...bean, "Obs": e.target.value }) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton icon="ri-checkbox-circle-line" eventClick={() => handleButtonClick("true")}>Aprobar Gestion</BasicButton>
                    </div>
                    <div className="col-md-4">
                        <BasicButton icon="ri-close-circle-line" eventClick={() => handleButtonClick("false")}>Rechazar Gestion</BasicButton>
                    </div>
                </div>
            }
            {view == 2 &&
                <>
                    <div className="col-md-4">
                        <BasicButton eventClick={() => { setView(1) }} icon="ri-arrow-left-line" children={`Volver`} />
                    </div>
                    <div className="col-md-12">
                        <MisPlanesPreparadorComponentEditor dataItem={props} idlnArea={bean.IDAdquisitionPlanFunctionalID} onChange={(e) => { setPaa(e) }} />
                    </div>
                    <div className="col-md-4">
                        <BasicButton icon="ri-send-plane-line" eventClick={() => {
                            if (paa.IDAdquisitionItem) {
                                enviardata({
                                    ...bean,
                                    IDAdquisitionItem: paa.IDAdquisitionItem,
                                    IDEmployeeManage: _single.getAccountID(),
                                });
                            } else {
                                toast.error("Debe seleccionar una Necesidad Valida")
                            }
                        }}>Seleccionar Necesidad</BasicButton>
                    </div>
                </>
            }
        </div>
    )
}